import { Component, computed, effect, NgZone, ChangeDetectionStrategy } from '@angular/core';
import { FieldWrapperComponent } from '@app/common-codes/components/nested-components/field-wrapper/field-wrapper.component';
import { FieldContextDirective } from '@app/common-codes/components/directives/FieldContext.directive';

import { FormsModule } from '@angular/forms';
import { Account } from '@app/common-codes/models/matwins-manager/Account.model';
import { GenetricDetailComponent } from '@app/common-codes/components/edit-components/generic-detail.component';
import { Register } from '@app/common-codes/decorators/DependencyInjectionRegistreyDecorators';
import { IStaticStylesConfig } from '@app/common-codes/skins/_primitives/IStaticStylesConfig';
import { MatwinsSkins } from '@app/common-codes/skins/global.skin';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { AccountBaseDetailComponent } from '@app/components/account/accountBase-detail.component';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { GenericValidationService } from '@app/common-codes/services/GenericValidationService';
import { AlertModalService } from '@app/common-codes/services/AlertModalService';
import { PermissionsService } from '@app/common-codes/services/Permissions.service';
import { OnReadyDirective } from '@app/common-codes/components/directives/OnReadyDirective';

@Register(Account)
@Component({
  selector: 'app-manager-account-detail',
  templateUrl: './account-detail.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, FormsModule, OnReadyDirective, FieldWrapperComponent, FieldContextDirective]
})
export class ManagerAccountDetailComponent extends AccountBaseDetailComponent<Account> {
  override ComponentEntityClass = Account;



  constructor(
    route: ActivatedRoute,
    router: Router,
    translationService: TranslationService,
    validationService: GenericValidationService,
    alertModalService: AlertModalService,
    permissionsService: PermissionsService,
    ngZone: NgZone
  ) {
    super(route, router, translationService, validationService, alertModalService, permissionsService, ngZone);
    this.alertModalService = alertModalService;
    effect(() => {
      const entity = this.editingEntity();
      if (entity) {
        // Lire la revision : si les listes arrivent en retard, l'effet repasse et les remplit.
        this.lookupService.revision();
        this.roleLookup.set(this.getLookupData('Role', 'Matwins.Core.Model.MatwinsManager'));
        this.languageLookup.set(this.getLookupData('i18nLanguage', 'Matwins.Core.Model.MatwinsManager'));
      }
    });
  }

  override getEmptyEntity(): Account {
    return new Account();
  }

  // override updateEditingEntity(property: keyof Account, value: any) {
  //   this.editingEntity.update(account => {
  //     if (account) {
  //       const newAccount = Object.assign(this.getEmptyEntity(), account);
  //       (newAccount as any)[property] = value;
  //       return newAccount;
  //     }
  //     return account;
  //   });
  // }

  // override parseToEntityInstance(): void {
  //   if (this.EntityInstance) {
  //     this.EntityInstance.name = this.editingEntity()!.name;
  //     this.EntityInstance.tenantPrefix = this.editingEntity()!.tenantPrefix;
  //     this.EntityInstance.email = this.editingEntity()!.email;
  //     this.EntityInstance.fK_Role = this.editingEntity()!.fK_Role;
  //   }
  // }
}
